import './Header.css';
import Svgs from 'assets/svgs';
import { useQuery } from 'hooks/useQuery';
import { LAST_NAV_TAB_KEY } from '../bottomNavigation/BottomNavigation';

interface HeaderBtnProps {
    img?: string,
    func?: () => void
}

interface HeaderProps {
    title: string,
    leftBtn?: HeaderBtnProps,
    rightBtn?: HeaderBtnProps,
    /** 서브페이지 여부 - true면 뒤로가기(좌측)와 닫기(우측) 버튼 모두 표시 */
    isSubPage?: boolean,
    onClose?: () => void
}

export const Header = ({ title, leftBtn, rightBtn, isSubPage, onClose }: HeaderProps) => {
    const { navigate } = useQuery();
    const defaultInset = {
        statusBarHeight : 0,
        navigationBarHeight : 0
    }
    const inset = window.__DEVICE__?.inset ?? defaultInset;
    const isDarkMode = window.__DEVICE__?.isDarkMode;

    // 뒤로가기 (history back)
    const handleBack = () => {
        navigate(-1);
    };

    // 닫기 (메인 탭으로 이동, 히스토리 초기화)
    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            // 마지막으로 방문한 Nav 탭으로 이동 (없으면 /home)
            // replace: true로 히스토리 초기화
            const lastNavTab = sessionStorage.getItem(LAST_NAV_TAB_KEY) || '/home';
            navigate(lastNavTab, { replace: true });
        }
    };

    const buttonRender = (btn: HeaderBtnProps) => {
        if(!!btn.img && btn.func) {
            return (
                <div className="header_btn_wrapper" onClick={btn.func}>
                    <img src={btn.img} style={isDarkMode ? {filter: 'invert(1)'} : {}} alt=""/>
                </div>
            )
        } else return <div className="header_btn_wrapper"></div>
    }

    return (
        <>
            <div className="header_wrapper" style={{ paddingTop: inset?.statusBarHeight }}>
                <div className='header_container'>
                    {isSubPage ?
                        buttonRender({img: Svgs.icBack24, func: handleBack}) :
                        buttonRender(leftBtn || {})
                    }
                    <span className='header_title'>{title}</span>
                    {isSubPage ?
                        buttonRender({img: Svgs.icClose24, func: handleClose}) :
                        buttonRender(rightBtn || {})
                    }
                </div>
            </div>
            <div className="header_padding" style={{height: 54 + inset?.statusBarHeight}}></div>
        </>
    )
}